<template>
  <Form
    form-name="Evaluator"
    :validation-schema="schemaEvaluatorForm"
    @submit="handleRegisterEvaluator"
    v-model="isValid"
  >
    <div class="d-flex w-100 flex-column gap-lg step justify-space-between guest-card">
      <div class="d-flex flex-column gap-sm align-center mt-sm">
        <ion-img :src="brandLogo" alt="Arribo Hero" class="question-image"></ion-img>
      </div>

      <div>
        <h1 class="font-sm grey bold-medium text-align-left px-sm">
          {{ t('evaluator.description') }}
        </h1>

        <div class="mt-xs d-flex gap-xs flex-column">
          <CustomInput
            form-name="Evaluator"
            type="text"
            :value="form.name"
            v-model="form.name"
            input-type="text"
            :label="t('profile.labels.name')"
            :placeholder="t('profile.labels.name')"
            name="name"
            class-name="custom-field"
            :clear-field="false"
            :read-only="true"
          />
          <CustomInput
            form-name="Evaluator"
            type="text"
            :value="form.lastName"
            v-model="form.lastName"
            input-type="text"
            :label="t('profile.labels.lastName')"
            :placeholder="t('profile.labels.lastName')"
            name="lastName"
            class-name="custom-field"
            :clear-field="false"
            :read-only="true"
          />
          <CustomInput
            form-name="Evaluator"
            type="text"
            :value="form.email"
            v-model="form.email"
            input-type="text"
            :label="t('profile.email.title')"
            :placeholder="t('profile.email.title')"
            name="email"
            class-name="custom-field"
            :clear-field="false"
            :read-only="true"
          />

          <ion-row size="12" class="ion-no-padding">
            <ion-col size="5" class="ion-no-padding"
              ><CustomInput
                form-name="Evaluator"
                type="text"
                :value="form.prefixPhone"
                v-model="form.prefixPhone"
                input-type="dial-code"
                :language="'en'"
                :label="t('profile.labels.code')"
                :placeholder="t('profile.labels.code')"
                name="prefixPhone"
                class-name="custom-field"
                :clear-field="false"
                :read-only="true"
            /></ion-col>
            <ion-col size="7" class="ion-no-padding pl-sm"
              ><CustomInput
                form-name="Evaluator"
                type="number"
                :value="form.phoneNumber"
                v-model="form.phoneNumber"
                input-type="number"
                :label="t('profile.labels.phoneNumber')"
                :placeholder="t('profile.labels.phoneNumber')"
                name="phoneNumber"
                class-name="custom-field"
            /></ion-col>
          </ion-row>
        </div>
      </div>

      <div class="d-flex justify-space-between d-flex justify-space-between mt-xs w-100">
        <ion-button
          :disabled="isLoading"
          type="submit"
          fill="solid"
          expand="block"
          size="large"
          color="primary"
          class="text-lg text-weight-bold w-100"
        >
          {{ t(`check-out.startCheck`) }}
        </ion-button>
      </div>

      <ion-progress-bar v-if="isLoading" type="indeterminate"></ion-progress-bar>
    </div>
  </Form>
</template>
<script setup lang="ts">
  import { IonButton, IonProgressBar, IonImg, IonRow, IonCol } from '@ionic/vue';
  import { useI18n } from 'vue-i18n';
  import brandLogo from '@/assets/images/brand-logo.png';
  import { ref } from 'vue';
  import { Form } from 'vee-validate';
  import CustomInput from '../shared/form/CustomInput.vue';
  import { useCheckInStore } from '@/stores/checkin-store';
  import { getDeviceInfo } from '@/plugins/device';
  import { DeviceInfo } from '@capacitor/device';
  import { storeToRefs } from 'pinia';
  import { useToast } from '@/composables/useToast';
  import { useSchemas } from '@/composables/useSchemas';

  const props = withDefaults(
    defineProps<{
      bookingId: string;
    }>(),
    {},
  );

  const { schemaEvaluatorForm } = useSchemas();
  const emit = defineEmits(['continue', 'back']);
  const { showToast } = useToast();
  const { registerEvaluator } = useCheckInStore();
  const { coords, evaluator } = storeToRefs(useCheckInStore());

  const isLoading = ref(false);
  const form = ref({
    name: '',
    lastName: '',
    email: '',
    prefixPhone: '',
    phoneNumber: '',
  });

  const { t } = useI18n();

  const isValid = ref(false);

  const handleRegisterEvaluator = async () => {
    try {
      isLoading.value = true;

      const device = (await getDeviceInfo()) as DeviceInfo & { lat?: number; lon?: number };
      device.lat = coords.value?.coords.latitude;
      device.lon = coords.value?.coords.longitude;

      const formEvaluator = {
        fullName: `${form.value.name} ${form.value.lastName}`,
        ...form.value,
      };

      const { success, data, error, msg } = await registerEvaluator(
        device,
        props.bookingId,
        formEvaluator,
      );
      if (success && data) {
        evaluator.value = data;
        await showToast(msg as string);
        emit('continue');
      } else {
        throw new Error(error);
      }
    } catch (error) {
      await showToast(error instanceof Error ? error.message : 'Unknown error', 'error');
    } finally {
      isLoading.value = false;
    }
  };
</script>

<style lang="scss" scoped>
  .step {
    border-radius: 16px;
    background: #ffffff;
    min-height: 200px;
    max-height: 700px;
    overflow: auto;
    color: black;
  }

  .guest-card {
    padding: var(--padding-xs);
  }

  @media (min-width: 500px) {
    .guest-card {
      padding: var(--padding-lg);
    }
  }
</style>
